// extracted by mini-css-extract-plugin
module.exports = {"container":"section_container__3WT2w","content":"section_content__253Ay","item":"section_item__2CoA7","readMore":"section_readMore__1j0rn"};